import dayjs from 'dayjs';

import type {DateObj, DateTimeObj, NaiveDateTimeObj} from './types';

import {not} from '../conditionalUtils';
import {datetimeObjToISOString} from './dateTimeObjToISOString';
import {isValidDateTimeString} from './isValidDateTimeString';
import {DEFAULT_DATE_STRING} from './utils';

export const dateTimeObjToTimestamp = (
  dateObj: DateObj | DateTimeObj | NaiveDateTimeObj | string,
) => {
  if (typeof dateObj === 'string') {
    if (not(isValidDateTimeString(dateObj))) {
      return dayjs(DEFAULT_DATE_STRING).valueOf();
    }

    return new Date(dateObj).getTime();
  }

  return dayjs(datetimeObjToISOString(dateObj)).valueOf();
};
